export const CANVAS_RESIZE_DEBOUNCE_MS = 100;
export const SEG_REFRESH_INTERVAL_MS = 5 * 1000;
export const MOUSE_CLICK_DIST = 5;
